import * as React from 'react'

function TableEmptyMessage({ children }) {
  return (
    <div className="px-3 py-3 text-txt text-sm flex items-center space-x-2">
      {children}
    </div>
  )
}

export default TableEmptyMessage
